import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    accountCareersite: []
  },
  mutations: {
    SET_ACCOUNT_CAREERSITE (store, items) {
      store.accounts.selectIds = items
    }
  },
  getters: {
    getAccountCareersite: (store, getters) => {
      return store.accounts.accountCareersite
    }
  },
  actions: {
    /*
    selectAccountCareersite
    */
    selectAccountCareersite ({commit, dispatch, getters, state}, filters) {
      return dispatch('getAccountCareersite', filters).then((response) => {
        commit('SET_ACCOUNT_CAREERSITE', response)
        return response
      })
    },
    /*
    getAccountCareersite
    */
    getAccountCareersite ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${id}/account-careersite`)
      .then((response) => {
        return response.data
      })
    },
    /*
    updateAccountCareersite
    */
    updateAccountCareersite ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${data._id}/account-careersite`, data)
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/accountCareersite.js